module.exports = __webpack_public_path__ + "img/support.a2bb2687.png";